// OrderLabelContext.ts
import { createContext, useContext } from "react";

export enum GetOrderLabels {
  ENQUIRY = "Enquiry",
  ORDER = "Order",
}

type OrderLabelContextType = {
  orderLabel: GetOrderLabels;
  isEnquiryOrder: boolean;
};

const OrderLabelContext =
  createContext<OrderLabelContextType | null>(null);

export const useOrderLabel = () => {
  const ctx = useContext(OrderLabelContext);
  if (!ctx) {
    throw new Error(
      "useOrderLabel must be used inside OrderLabelProvider"
    );
  }
  return ctx;
};

export const OrderLabelProvider = OrderLabelContext.Provider;
